import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'app-logo-box',
  imports: [RouterLink],
  templateUrl: './logo-box.component.html',
  styleUrl: './logo-box.component.scss'
})
export class LogoBoxComponent {}
